
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"}},[_c('path',{attrs:{"d":"M12,16.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.5h0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12 13.5L12 5.25","fill":"none","stroke-linecap":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z","fill":"none","stroke-width":"1.5"}})])])
          )
        }
      }
    